import { render, staticRenderFns } from "./SubmissionRoute.vue?vue&type=template&id=3bba1978&scoped=true&"
import script from "./SubmissionRoute.vue?vue&type=script&lang=js&"
export * from "./SubmissionRoute.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionRoute.vue?vue&type=style&index=0&id=3bba1978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba1978",
  null
  
)

export default component.exports